import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CyberCareRoutingModule } from './cyber-care-routing.module';
import { CyberCareContainerComponent } from './cyber-care-container/cyber-care-container.component';
import { CyberCareCoverageComponent } from './cyber-care-coverage/cyber-care-coverage.component';
import { CyberCareClaimComponent } from './cyber-care-claim/cyber-care-claim.component';
import { TranslationModule } from '@proximus/ng-common';
import { SharedModule } from '../shared/shared.module';
import { EffectsModule } from '@ngrx/effects';
import { CyberCareEffects } from './store/effects/cyber-care.effects';
import { CyberCareCeaseModalComponent } from './cyber-care-cease-modal/cyber-care-cease-modal.component';
import { CyberCareYearlyPriceComponent } from './cyber-care-container/cyber-care-yearly-price/cyber-care-yearly-price.component';

@NgModule({
  declarations: [
    CyberCareContainerComponent,
    CyberCareCoverageComponent,
    CyberCareClaimComponent,
    CyberCareCeaseModalComponent,
    CyberCareYearlyPriceComponent,
  ],
  imports: [
    CommonModule,
    CyberCareRoutingModule,
    TranslationModule,
    SharedModule,
    EffectsModule.forFeature([CyberCareEffects]),
  ],
})
export class CyberCareModule {}
